import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { FAQ_ITEMS, ACTIVITIES, THINGS_TO_BRING, PHOTOS, SITE } from "../data/content";
import Reveal from "../components/Reveal";
import SectionHeading from "../components/SectionHeading";
import PageHero from "../components/PageHero";

export default function FAQ() {
  return (
    <main data-testid="faq-page">
      <PageHero
        image={PHOTOS.lakeWake}
        eyebrow="Frequently Asked"
        title="Plan your trip with confidence."
        subtitle="The questions guests ask us most, plus a few tips to make your stay even better."
      />

      <section className="py-24 bg-[var(--ec-cream)]">
        <div className="max-w-3xl mx-auto px-5 lg:px-10">
          <Reveal>
            <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
              {FAQ_ITEMS.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`item-${i}`}
                  className="bg-white rounded-2xl border border-[var(--ec-sand)] overflow-hidden"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="px-6 py-5 text-left font-display text-lg text-[var(--ec-navy)] hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="px-6 pb-6 text-[var(--ec-charcoal)]/80 leading-relaxed">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 grid lg:grid-cols-2 gap-10">
          <Reveal>
            <SectionHeading eyebrow="Things to do" title="Pick your kind of lake day." />
            <div className="flex flex-wrap gap-2">
              {ACTIVITIES.map((a) => (
                <span
                  key={a}
                  className="text-sm px-4 py-2 rounded-full bg-[var(--ec-foam)] text-[var(--ec-navy)] font-medium"
                  data-testid={`faq-activity-${a.toLowerCase().replace(/[^a-z]/g, "-")}`}
                >
                  {a}
                </span>
              ))}
            </div>
          </Reveal>
          <Reveal delay={120}>
            <SectionHeading eyebrow="What to bring" title="A few things to pack." subtitle="Cabins come with the basics — these extras will round out a great stay." />
            <ul className="grid grid-cols-2 gap-2">
              {THINGS_TO_BRING.map((t) => (
                <li
                  key={t}
                  className="text-sm px-4 py-3 rounded-xl bg-[var(--ec-sand-soft)] text-[var(--ec-navy)] font-medium"
                  data-testid={`faq-bring-${t.toLowerCase().replace(/[^a-z]/g, "-")}`}
                >
                  {t}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </section>

      <section className="py-20 bg-[var(--ec-navy)] text-white">
        <div className="max-w-5xl mx-auto px-5 lg:px-10 text-center">
          <h2 className="font-display text-4xl sm:text-5xl text-white">Still have questions?</h2>
          <p className="mt-4 text-white/75 max-w-xl mx-auto">
            Give us a call at {SITE.phoneDisplay} or send a message — we're happy to help you plan.
          </p>
          <div className="mt-8 flex flex-wrap gap-3 justify-center">
            <a
              href={`tel:${SITE.phoneRaw}`}
              className="inline-flex items-center gap-2 bg-[var(--ec-lake)] hover:bg-[var(--ec-lake-dark)] text-white font-semibold px-7 py-4 rounded-full btn-lift"
              data-testid="faq-call-cta"
            >
              Call {SITE.phoneDisplay}
            </a>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 border border-white/50 text-white hover:bg-white/10 font-semibold px-7 py-4 rounded-full btn-lift"
              data-testid="faq-contact-cta"
            >
              Send a Message
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
